import { render, staticRenderFns } from "./PrdInDetailDialog.vue?vue&type=template&id=0d0d6708&scoped=true&"
import script from "./PrdInDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PrdInDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrdInDetailDialog.vue?vue&type=style&index=0&id=0d0d6708&scoped=true&lang=css&"
import style1 from "./PrdInDetailDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d6708",
  null
  
)

export default component.exports